export default {
  setItem: (key, value) => Promise.resolve(localStorage.setItem(key, value)),
  getItem: key => Promise.resolve(localStorage.getItem(key)),
  removeItem: key => Promise.resolve(localStorage.removeItem(key)),
}
